import * as React from 'react';
import './index.scss';
import QRCode from 'qrcode.react';
import InviteImg from './hooks/Image';
import { HYToast, HYSaveInAlbum, HYShare } from '@hy-hybrid/kiwi-js-sdk';
import { getURLParam } from './../../utils';
import store, { useAppSelector } from './../../toolkit';
import { Provider } from 'react-redux';
import { reportFuc } from '../../utils';
import classNames from 'classnames';
import Serve from '../../serve';
console.log('加载地址', location.href);
const { shareTo } = HYShare;
const { showToast } = HYToast;
const { saveImageToPhotosAlbum } = HYSaveInAlbum;
const { useState, useEffect, useCallback } = React;

const Qrcode: React.FC = () => {
  const [qrurl, setQrUrl] = useState('');
  const { uid } = useAppSelector((state) => state.base);
  const iOld = getURLParam('iOld');
  const data = JSON.parse(getURLParam('qrcodeData'));
  const renderQrcode = async () => {
    const shorturl = await Serve.getShortUrl({
      sUrl:
        location.protocol +
        '//' +
        location.host +
        location.pathname.replace(/\/qrcode.html/, `/picshare1.html`),
      iLevel: 1,
      sUrlSuffix: 'picshare1.html'
    });
    const { data } = shorturl;
    console.log(
      'shorturl: ',
      data.sShotUrl + `?code=${getURLParam('code')}&uid=${uid}&iType=4&client=1`
    );
    let url =
      'https://' +
      data.sShotUrl +
      `?code=${getURLParam('code')}&uid=${uid}&iType=4&client=1`;

    if (/test-hd/g.test(location.host)) {
      url = (
        location.protocol +
        '//' +
        location.host +
        location.pathname
      ).replace(
        /\/qrcode.html/,
        `/picshare1.html?code=${getURLParam(
          'code'
        )}&uid=${uid}&iType=4&client=1`
      );
    }

    setQrUrl(url);
  };

  // const qrcode = (
  //   <QRCode
  //     value={(
  //       location.protocol +
  //       '//' +
  //       location.host +
  //       location.pathname
  //     ).replace(
  //       /\/qrcode.html/,
  //       `/picshare1.html?code=${getURLParam(
  //         'code'
  //       )}&uid=${uid}&iType=4&client=1`
  //     )}
  //     renderAs={'svg'}
  //   />
  // );
  const [download, setDownLoad] = useState<any>(undefined);
  useEffect(() => {
    reportFuc(
      'sys/pageview/ldx/scanpage',
      '系统/页面展示/老带新/面对面扫码页曝光',
      {}
    );
    renderQrcode();
  }, []);
  return (
    <>
      <div className={classNames('Qrcode', { new: iOld === 'false' })}>
        <div className="code">{<QRCode value={qrurl} renderAs={'svg'} />}</div>
        {iOld === 'false' && (
          <div className="desc">
            <p>微信/QQ扫一扫，下载虎牙看直播</p>
            <span>也可使用浏览器或虎牙直播App扫码</span>
          </div>
        )}
        <div className="code-share" />
        {iOld === 'false' && (
          <ul className="data">
            {[0, 1].map((item) => (
              <li key={item}>
                <span className="text-1">
                  {(
                    JSON.parse(data)[['newCash', 'backCash'][item]] / 100
                  ).toFixed(1)}
                </span>
                <span className="text-2">元现金</span>
                <br />
                <span className="text-3">
                  +
                  {(
                    JSON.parse(data)[['newTotal', 'backTotal'][item]] / 100
                  ).toFixed(1)}
                </span>
                <span className="text-4">元礼包</span>
              </li>
            ))}
            <li>
              <span className="text-1">随机</span>
              <span className="text-2">现金</span>
              <br />
              <span className="text-3">+ 随机</span>
              <span className="text-4">礼包</span>
            </li>
          </ul>
        )}
        {qrurl != '' && download && (
          <ul className="share-list">
            {[
              ['weixin', '微信'],
              ['qq', 'QQ'],
              ['circle', '朋友圈'],
              ['save', '保存至本地']
            ].map((item, idx) => (
              <li
                key={idx}
                onClick={() => {
                  if (!download && qrurl == '')
                    return showToast({
                      message: '图片生成中，请稍后再试!'
                    });
                  switch (item[0]) {
                    case 'weixin':
                    case 'qq':
                    case 'circle':
                      reportFuc(
                        'usr/click/ldx/scanpage/picsharemode',
                        '用户/点击/老带新/面对面扫码页/图片分享方式点击',
                        { pic_share_mode: idx }
                      );
                      shareTo({
                        platform: item[0],
                        imageData: download,
                        mediaType: '2'
                      });
                      break;
                    case 'save':
                      reportFuc(
                        'usr/click/ldx/scanpage/picsharemode',
                        '用户/点击/老带新/面对面扫码页/图片分享方式点击',
                        { pic_share_mode: 3 }
                      );
                      saveImageToPhotosAlbum({
                        imgData: download
                      })
                        .then(() => {
                          showToast({
                            message: '保存成功!'
                          });
                        })
                        .catch(() => {
                          showToast({
                            message: '保存失败!'
                          });
                        });
                      break;
                    default:
                      return;
                  }
                }}
              >
                <i className={item[0]} />
                <p>{item[1]}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="cover" />
      {qrurl != '' && (
        <InviteImg finish={setDownLoad} iOld={iOld === 'true'}>
          {<QRCode value={qrurl} renderAs={'svg'} />}
        </InviteImg>
      )}
    </>
  );
};

export default (): React.ReactNode => (
  <Provider store={store}>
    <Qrcode />
  </Provider>
);
